import { cn, ia } from 'lib/helpers/utility';

export const getPanelClasses = ({ isFixed, position, options, panelClassName }) => {
  return cn(
    'z-[100] flex flex-col max-h-[70dvh] min-w-[120px] max-w-[712px] gap-y-2 rounded-md bg-white py-2 border border-solid border-neutral-200 shadow-[0px_0px_8px_0px_rgba(65,70,81,0.08)]',
    'animate-float-in motion-reduce:animate-none',
    'origin-top',
    !isFixed && 'absolute mt-[6px]',
    !isFixed && position === 'left' ? 'right-0' : 'left-0',
    ia(options) ? 'overflow-y-auto' : 'overflow-hidden',
    panelClassName
  );
};
